<template>
  <div>
    <Header />
    <Article />
    <Status :key="statusRefreshKey" />
  </div>
</template>
<script>
import Header from '@/components/common/layout/Header.vue'
import Article from '@/components/common/layout/Article.vue'
import Status from '@/components/status/Status.vue'
import { mapState } from 'vuex'

export default {
  name: 'DefaultLayout',
  components: {
    Header,
    Article,
    Status,
  },
  computed: {
    ...mapState('status', ['statusRefreshKey']),
  },
}
</script>
